import { Query } from 'material-table';
import type { RootState } from 'redux/rootReducer';
import { MonthlyReport } from './types';

type SortableMonthlyReportsColumn = {
  sortField?: string;
};

export const selectMonthlyReportsSortParam = (query: Query<MonthlyReport>): string | undefined => {
  if (!query.orderBy || !query.orderDirection) {
    return undefined;
  }

  const orderByWithSortField = query.orderBy as SortableMonthlyReportsColumn;
  if (typeof orderByWithSortField.sortField !== 'string') {
    return undefined;
  }

  const sortableField = orderByWithSortField.sortField;
  if (!sortableField) {
    return undefined;
  }

  if (query.orderDirection === 'desc') {
    return `-${sortableField}`;
  }

  return sortableField;
};

export const selectMonthlyReportsHiddenColumns = (state: RootState): string[] =>
  state.monthlyReports.hiddenColumns;

export const selectMonthlyReportsData = (state: RootState): MonthlyReport[] =>
  state.monthlyReports.reports;

export const selectMonthlyReportsTotal = (state: RootState): number => state.monthlyReports.total;

export const selectMonthlyReportsStatus = (state: RootState): 'init' | 'loading' | 'loaded' =>
  state.monthlyReports.status;
